import createIcon from '../../createIcon';

/**
 * @component @name Wc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAyMlYxNC41SDMuNVY5QzMuNSA3LjkgNC40IDcgNS41IDdIOC41QzkuNiA3IDEwLjUgNy45IDEwLjUgOVYxNC41SDlWMjJINVpNMTcuNSAyMlYxNkgyMC41TDE3Ljk2IDguMzdDMTcuNjggNy41NSAxNi45MiA3IDE2LjA2IDdIMTUuOTRDMTUuMDggNyAxNC4zMSA3LjU1IDE0LjA0IDguMzdMMTEuNSAxNkgxNC41VjIySDE3LjVaTTcgNkM4LjExIDYgOSA1LjExIDkgNEM5IDIuODkgOC4xMSAyIDcgMkM1Ljg5IDIgNSAyLjg5IDUgNEM1IDUuMTEgNS44OSA2IDcgNlpNMTYgNkMxNy4xMSA2IDE4IDUuMTEgMTggNEMxOCAyLjg5IDE3LjExIDIgMTYgMkMxNC44OSAyIDE0IDIuODkgMTQgNEMxNCA1LjExIDE0Ljg5IDYgMTYgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wc = createIcon('Wc', [
  [
    'path',
    {
      d: 'M5 22V14.5H3.5V9C3.5 7.9 4.4 7 5.5 7H8.5C9.6 7 10.5 7.9 10.5 9V14.5H9V22H5ZM17.5 22V16H20.5L17.96 8.37C17.68 7.55 16.92 7 16.06 7H15.94C15.08 7 14.31 7.55 14.04 8.37L11.5 16H14.5V22H17.5ZM7 6C8.11 6 9 5.11 9 4C9 2.89 8.11 2 7 2C5.89 2 5 2.89 5 4C5 5.11 5.89 6 7 6ZM16 6C17.11 6 18 5.11 18 4C18 2.89 17.11 2 16 2C14.89 2 14 2.89 14 4C14 5.11 14.89 6 16 6Z',
      key: 'm6zx5o',
    },
  ],
]);

export default Wc;
